import { Link } from "react-router-dom";
import type { ReactNode } from "react";

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
  icon?: ReactNode;
}

export default function SectionHeader({
  title,
  subtitle,
  moreTo,
  moreLabel = "查看更多",
  icon,
}: SectionHeaderProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5 md:mb-7">
      <div className="flex items-center gap-3">
        {icon && (
          <span className="w-9 h-9 md:w-10 md:h-10 rounded-lg bg-primary-500 text-white flex items-center justify-center shrink-0">
            {icon}
          </span>
        )}
        <div>
          <h2 className="text-xl md:text-2xl font-semibold text-foreground-950 tracking-tight">
            {title}
          </h2>
          {subtitle && (
            <p className="text-xs md:text-sm text-foreground-500 mt-1">{subtitle}</p>
          )}
        </div>
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="hidden sm:inline-flex items-center gap-1 text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          {moreLabel}
          <i className="ri-arrow-right-line" />
        </Link>
      )}
    </div>
  );
}